<footer class="app-footer">
  <section class="footer-container">
    <div class="footer-warning">
      <p class="warning-text">
        <strong>Warning:</strong> This is a portfolio site. You do not enter real bank details or sensitive financial information.
      </p>
    </div>

    <div class="footer-links">
      <a 
        href="https://jorgegerardo.github.io/WhoAmI" 
        target="_blank" 
        rel="noopener noreferrer"
        class="footer-link"
        title="Visit my personal website"
      >
        🌐 About me
      </a>
      <a 
        href="https://www.linkedin.com/in/jorge-saul-gerardo-rojo-8a8170264" 
        target="_blank" 
        rel="noopener noreferrer"
        class="footer-link"
        title="Visit my LinkedIn profile"
      >
        💼 LinkedIn
      </a>
    </div>

    <div class="footer-copyright">
      <p>&copy; {{ currentYear }} - GeorgeStore. All rights reserved.</p>
    </div>
  </section>
</footer>
